export default {
    fieldTitle: '',
    fieldText: '',
    fieldSection: '',
    fieldImg: '',

    isCreate: false,
    isTopicCreate: false
}
